/**
 * Este mixin lo vamos a utilizar para almacenar las traducciones de cada recurso en un array object
 */
export default {
  methods: {
    /**
     * Truncar una cadena segun la longitud que se pasa como parametro
     * @param {*} text : cadena a truncar
     * @param {*} length : longitud a truncar
     * @param {*} suffix : cadena para completar
     */
    truncate(text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      }
      return text;
    },
    /**
     * Obtener la traduccion del recurso en función del lenguaje global seleccionado.
     * @param {*} itemArray Array de object con las traducciones del recurso.
     */
    getTranslation(itemArray) {
      if (itemArray.find(p => p.LANGUAGE === this.languageGlobal)) {
        return itemArray.find(p => p.LANGUAGE === this.languageGlobal).TEXTO;
      }
      return null;
    },
    /**
     * Retorna la traducción para cada elemento del recurso Plantilaa
     * En el caso que supere los 45 caracteres se corta y se agrega ...
     * @param {*} itemArray
     */
    getTranslationTemplate(itemArray) {
      if (itemArray.find(p => p.LANGUAGE === this.languageGlobal)) {
        return this.truncate(itemArray.find(p => p.LANGUAGE === this.languageGlobal).TEXTO, 45, '...');
      }
      return null;
    },
    /**
     *
     * @param {*} prefijo : Indica nombre del campo a traducir 'TEXTO_','PLANILLA_','FICHERO_'
     * @param {*} itemSelected : Objeto con los campos devuelto por la consulta
     * @param {*} objectTranslation : Objecto Array con las claves LANGUAGE: 'XX', TEXTO: 'TRADUCCION' , con todas las traducciones del recurso.
     */
    setTranslation(prefijo, itemSelected, objectTranslation) {
      const arrayLanguage = this.languages;
      Object.keys(itemSelected).forEach((key) => {
        const language = key.split('_');
        if (language.length > 1) {
          const idioma = language[language.length - 1];
          if (arrayLanguage.includes(idioma)) {
            const item = {
              LANGUAGE: idioma,
              TEXTO: itemSelected[`${prefijo + idioma}`],
            };
            objectTranslation.push(item);
          }
        }
      });
    },
  },
};
